<template lang="pug">
  SspLayout(area="core")
    SspSaveForm(@onSubmit="save" :saving="saving" :saveDisabled="!isValid")
      .panel-body
        .container-fluid
          .form-horizontal
            .form-group
              label.col-sm-4.control-label Name
              .col-sm-8
                input.form-control(v-model="atiGroup.name" placeholder="Validation response group name")

            .form-group
              label.col-sm-4.control-label Default
              .col-sm-1
                input.form-control(type="checkbox" v-model="atiGroup.default")

            .form-group
              label.col-sm-4.control-label Validation responses
              .col-sm-8
                GenericTable
                  tr(slot="thead")
                    th Name
                    th Type
                    th
                  tr(v-for="(a, index) in atis")
                    td {{a.name}}
                    td
                      span(v-if="a.type === 'N'") STANDARD
                      span(v-if="a.type === 'W'") WARNING
                      span(v-if="a.type === 'F'") FINAL
                    td.actions
                      .fa.fa-times.clickable(@click="removeAti(index)")

            .form-group
              label.col-sm-4.control-label Add validation Response
              .col-sm-8
                AtiSelect(v-model="ati")

</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import GenericTable from '@/components/common/GenericTable'
import AtiSelect from '@/components/ssp/AtiSelect'

export default {
  data: () => ({
    saving: false,
    atiGroup: {
      name: null,
      default: false
    },
    atis: [],
    ati: null,
    errorMsg: null
  }),
  created() {
    if (this.atiGroupId) {
      this.getAtiGroup()
    }
  },
  methods: {
    save() {
      this.saving = true
      const req = {}
      const atis = this.atis.map((a) => a.id)

      req.name = this.atiGroup.name
      req.default = this.atiGroup.default
      req.id = this.atiGroupId
      if (this.atis) {
        req.atiIds = {
          id: atis
        }
      }

      const call = !this.atiGroupId ? Core.createAtiGroup(req) : Core.updateAtiGroup(this.atiGroupId, req)
      const action = !this.atiGroupId ? 'created' : 'updated'
      call
        .then(() => {
          miniToastr.success(`Validation response group successfully ${action}`)
          this.$router.push({ name: 'atiGroups' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    getAtiGroup() {
      Core.getAtiGroup(this.atiGroupId)
        .then((resp) => {
          this.atiGroup = resp.data
          if (resp.data.atis.ati) {
            this.atis = resp.data.atis.ati
          }
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    removeAti(index) {
      this.atis.splice(index, 1)
    }
  },
  watch: {
    ati() {
      Core.getAti(this.ati.value)
        .then((resp) => {
          this.atis.push(resp.data)
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  computed: {
    atiGroupId() {
      return parseInt(this.$route.params.id, 10)
    },
    isValid() {
      return this.atiGroup.name
    }
  },
  components: {
    GenericTable,
    AtiSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/ati/AtiGroupEdit.vue